export default {"src":"/_next/static/media/KDP.36b422a0.svg","height":18,"width":18};